import PlusIcon from "@heroicons/react/20/solid/PlusIcon";
import XMarkIcon from "@heroicons/react/20/solid/XMarkIcon";
import { Link, useSearchParams } from "react-router-dom";

import useFCSubscriptionStore from "@hsl/fc-subscription/store";
import { type FundDataWithType } from "@hsl/fund-explorer/metaSchemas";

import { Translate } from "../../../../../hooks/useTranslation";
import { Card } from "../../Card";
import { type FlowType } from "../../FlowStepper";

export const SelectFunds = ({ flowType }: { flowType: FlowType }) => {
    const [params] = useSearchParams();
    const latestFC = useFCSubscriptionStore((store) => store.latestFC);
    const basket = useFCSubscriptionStore((store) => store.selectionBasket);
    const reset = useFCSubscriptionStore((store) => store.resetFlow);
    const toggleBasketItem = useFCSubscriptionStore(
        (store) => store.toggleBasketItem,
    );
    const handleItemRemove = (item: FundDataWithType) => {
        reset();
        toggleBasketItem(item);
    };

    const backParams = new URLSearchParams(params);
    backParams.delete("step");

    return (
        <>
            <p className="my-2 text-sm">
                <Translate>
                    {flowType === "watch"
                        ? "Add the following funds to your watchlist"
                        : "Receive emails when fact sheets and other fund literature is published or updated for the following funds"}
                </Translate>
                :
            </p>
            <Card>
                {basket.funds.map((item) => (
                    <p className="text my-1.5" key={item.data.id}>
                        {item.data.data.name}
                        <button
                            aria-roledescription={`Remove ${item.data.data.name} from selection`}
                            className="ml-2 inline pb-0.5 align-middle font-medium"
                            onClick={() => handleItemRemove(item)}
                        >
                            <XMarkIcon width={16} className="text-taupe-gray" />
                        </button>
                    </p>
                ))}
                <Link
                    to={latestFC + "?" + backParams.toString()}
                    className="text-core-blue my-4 flex items-center gap-1"
                >
                    <PlusIcon width={20} />
                    <span className="underline">
                        <Translate>Add Funds</Translate>
                    </span>
                </Link>
            </Card>
        </>
    );
};
